/**
 * chatService — wrapper around the /api/chat/v2 endpoints.
 *
 * The streaming endpoint is intentionally NOT abstracted into a high-level
 * "ask question" helper here.  The page consumes api.stream() directly inside
 * its component so it can mutate React state on each chunk without an extra
 * subscription layer.
 */
import { api } from "../lib/api";

/** GET /api/chat/v2/sessions — list of sessions for the active department. */
export async function listSessions() {
  const data = await api.get("/api/chat/v2/sessions");
  return data.sessions || [];
}

/** DELETE /api/chat/v2/sessions/<session_id> */
export async function deleteSession(sessionId) {
  return api.del(`/api/chat/v2/sessions/${encodeURIComponent(sessionId)}`);
}

/** GET /api/chat/v2/history?session_id=<id> — turns for a single session. */
export async function fetchHistory(sessionId) {
  const data = await api.get(`/api/chat/v2/history?session_id=${encodeURIComponent(sessionId)}`);
  return data.history || [];
}

/** GET /api/chat/v2/memory — global per-user memory string. */
export async function getMemory() {
  const data = await api.get("/api/chat/v2/memory");
  return data.memory || "";
}

/** POST /api/chat/v2/memory — overwrite the global memory. */
export async function saveMemory(memory) {
  return api.post("/api/chat/v2/memory", { memory });
}

/**
 * POST /api/chat/v2/stream — async iterator over SSE frames.
 *
 * Usage in the page:
 *   for await (const frame of streamChat({ query, session_id })) {
 *     if (frame.type === "init")  setSessionId(frame.session_id);
 *     if (frame.type === "chunk") appendToCurrentMessage(frame.content);
 *     if (frame.type === "done")  finalizeMessage();
 *     if (frame.type === "error") showError(frame.error);
 *   }
 */
export function streamChat({ query, session_id }) {
  return api.stream("/api/chat/v2/stream", { query, session_id });
}
